import React from "react";

function Footer() {
  return (
    <footer className="custom-footer">
      <div className="container">
        <div className="row">
          <div className="col col-auto">
            <img src="/img/nr_logo.png" alt="NR Logo"/>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
